import { ActionsUnion, createAction } from "store/helper";

import { IUrlQueryParamsFeatureRegisterViewPayload, IUrlQueryParamsFeatureUnregisterViewPayload } from "./interfaces";

export enum UrlQueryParamsFeatureActionNames {
  REGISTER_VIEW = "FEATURES/URL_QUERY_PARAMS/REGISTER_VIEW",
  UNREGISTER_VIEW = "FEATURES/URL_QUERY_PARAMS/UNREGISTER_VIEW",
}

export const UrlQueryParamsFeatureActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  registerView: (payload: IUrlQueryParamsFeatureRegisterViewPayload) =>
    createAction(UrlQueryParamsFeatureActionNames.REGISTER_VIEW, payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  unregisterView: (payload: IUrlQueryParamsFeatureUnregisterViewPayload) =>
    createAction(UrlQueryParamsFeatureActionNames.UNREGISTER_VIEW, payload),
};

export type UrlQueryParamsFeatureAction = ActionsUnion<typeof UrlQueryParamsFeatureActions>;
